import React, { useState, useEffect, useCallback, memo } from "react";

import { MainD, Pill, Ball } from "../../spheres/main/MainStyled";
const colors = [
  "#413f62",
  "#e1be27",
  "#a67ed9",
  "#8cbb67",
  "#fa8046",
  "#828aef",
  "#78bec5",
  "#de4d78",
];

// let betInfo = {
//   dealer: ["1", "4", "2", "2", "4"],
//   player: ["1", "2", "1", "6", "3"],
//   winPositionsDealer: ["0", "1", "1", "1", "1"],
//   winPositionsPlayer: ["1", "0", "1", "0", "0"],
// };
function BallsGrid({ dealer, player, winPositionsDealer, winPositionsPlayer }) {
  const [upRow, setupRow] = useState([null, null, null, null, null]);
  const [downRow, setdownRow] = useState([null, null, null, null, null]);

  const twoToOne = useCallback((a, b) => {
    let arr = [null, null, null, null, null];
    return arr.map((x, i) => [a[i], b[i]]);
  }, []);

  useEffect(() => {
    if (!(dealer || player || winPositionsDealer || winPositionsPlayer)) return;

    setTimeout(() => {
      setupRow(twoToOne(dealer, winPositionsDealer));
      setdownRow(twoToOne(player, winPositionsPlayer));
    }, 300);
  }, [
    dealer,
    player,
    winPositionsDealer,
    winPositionsPlayer,
    setupRow,
    setdownRow,
    twoToOne,
  ]);
  return (
    <MainD>
      {upRow.map((b, i) => (
        <Pill key={i}>
          {b && b[0] !== "0" && (
            <Ball
              isDifferent={b[0] === "7"}
              move={b[1] === "1"}
              color={colors[b[0]]}
            //   canScale={canScaleUp}
            //   fadeOut={fadeOut}
            //   delay={!isFast && 500 * i + "ms"}
            />
          )}
        </Pill>
      ))}
      {downRow.map((b, i) => (
        <Pill key={i} downRow>
          {b && b[0] !== "0" && (
            <Ball
              isDifferent={b[0] === "7"}
              move={b[1] === "1"}
              //   canScale={canScaleDown}
              color={colors[b[0]]}
            //   fadeOut={fadeOut}
            //   delay={!isFast && 500 * i + "ms"}
            />
          )}
        </Pill>
      ))}
    </MainD>
  );
}

export default memo(BallsGrid);
